import { Component, Input } from '@angular/core';

@Component({
  selector: 'showcharacter',
  template: `<h5 style="color:#ffff">Mobile No:  {{name}}</h5>`,
  styles: [`h1 { font-family: Lato; }`]
})
export class showcharacterComponent  {
  @Input() name: string;
}
